<template>
    <div id="dispatch-modal">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="card">
                        <div class="card-header">Informacion de Despacho</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div>
                                        <label>Fecha de Envio - Desde bodega</label>
                                        <input v-model="dispatchDate" class="form-control" type="date" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label>N° Guia de Despacho</label>
                                    <input class="form-control" type="text" v-model="guideNumber" />
                                </div>
                                <div class="col-md-6">
                                    <button :disabled="!dispatchDate || !guideNumber" class="btn btn-success" @click="dispatchSelection" style="margin-top: 30px">
                                        Despachar Muestras
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <strong>¿Esta seguro de realizar el despacho de la siguiente
                        muestras?</strong>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="card" v-if="detailNew.length > 0">
                        <div class="card-header">
                            <h4>Nuevo Producto</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                    </tr>
                                </thead>
                                <tbody v-for="dnew in detailNew" :key="dnew.id">
                                    <tr>
                                        <td>{{ dnew.brand }}</td>
                                        <td>
                                            {{ dnew.comercialMix }} - {{ dnew.comercialMixCode }}
                                        </td>
                                        <td>
                                            {{ dnew.variety }} {{ dnew.valley }}
                                            {{ dnew.quality }}
                                        </td>
                                        <td>{{ dnew.finalHarvest }}</td>
                                        <td>
                                            {{ dnew.quantity }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="card" v-if="detailFinish.length > 0">
                        <div class="card-header">
                            <h4>Producto Terminado</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>SKU</th>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                    </tr>
                                </thead>
                                <tbody v-for="dpt in detailFinish" :key="dpt.id">
                                    <tr>
                                        <td>{{ dpt.sku }}</td>
                                        <td>{{ dpt.brand }}</td>
                                        <td>{{ dpt.comercialMix }} - {{ dpt.comercialMixCode }}</td>
                                        <td>
                                            {{ dpt.variety }} {{ dpt.valley }}
                                            {{ dpt.quality }}
                                        </td>
                                        <td>{{ dpt.finalHarvest }}</td>
                                        <td>
                                            {{ dpt.quantity }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="card" v-if="detailBottle.length > 0">
                        <div class="card-header">
                            <h4>Producto Guarda Botella</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>SKU</th>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                    </tr>
                                </thead>
                                <tbody v-for="dbt in detailBottle" :key="dbt.id">
                                    <tr>
                                        <td>{{ dbt.sku }}</td>
                                        <td>{{ dbt.brand }}</td>
                                        <td>{{ dbt.comercialMix }} - {{ dbt.comercialMixCode }}</td>
                                        <td>
                                            {{ dbt.variety }} {{ dbt.valley }}
                                            {{ dbt.quality }}
                                        </td>
                                        <td>{{ dbt.finalHarvest }}</td>
                                        <td>
                                            {{ dbt.quantity }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Put } from "@/helper/axios";
export default {
    name: "dispatchModal",
    props: [
        "id",
        "detailNew",
        "detailFinish",
        "detailBottle",
        "shippingDate",
        "internalGuideNumber",
    ],
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Put,
            dispatchDate: "",
            guideNumber: "",
        };
    },
    methods: {
        dispatchSelection() {
            this.$emit("dispatch", this.dispatchDate, this.guideNumber);
        },
    },
};
</script>

<style scoped></style>
